var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTransfer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25 1.03125C11.6211 1.03125 0.78125 11.8711 0.78125 25.25C0.78125 38.6289 11.6211 49.4688 25 49.4688C38.3789 49.4688 49.2188 38.6289 49.2188 25.25C49.2188 11.8711 38.3789 1.03125 25 1.03125Z",
    fill: "#959CA0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.875 30.125H16.7031L20.1719 26.4219C20.5938 25.9531 20.5938 25.25 20.125 24.8281C19.6562 24.4062 18.9531 24.4062 18.5312 24.875L13.2812 30.5C12.8594 30.9219 12.8594 31.625 13.2812 32.0469L18.5312 37.6719C18.7656 37.9062 19.0469 38 19.375 38C19.6094 38 19.8906 37.9062 20.125 37.7188C20.5938 37.2969 20.5938 36.5938 20.1719 36.125L16.7031 32.375H35.875C36.4844 32.375 37 31.9062 37 31.25C37 30.6406 36.4844 30.125 35.875 30.125ZM14.125 21.875H33.25L29.7812 25.625C29.3594 26.0938 29.3594 26.7969 29.8281 27.2188C30.2969 27.6406 31 27.6406 31.4219 27.1719L36.6719 21.5469C37.0938 21.125 37.0938 20.4219 36.6719 20L31.4219 14.375C31.1875 14.1406 30.9062 14 30.625 14C30.3438 14 30.0625 14.1406 29.8281 14.3281C29.3594 14.75 29.3594 15.4531 29.7812 15.9219L33.25 19.625H14.125C13.4688 19.625 13 20.1406 13 20.75C13 21.4062 13.4688 21.875 14.125 21.875Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransfer);
export default __webpack_public_path__ + "static/media/transfer.20c3b991.svg";
export { ForwardRef as ReactComponent };